// Members ---------------------------------------------------------------------
import { fleetUserHelpers } from 'src/apps/fleet/app/components/fleetUserHelpers';
import { cloudEnterpriseFleetApiClient as fleetApiClient } from '../clients/cloudEnterpriseFleetApiClient';

export const getMembers = async () =>
  fleetApiClient.GET('/fleet/v1/users').then((res) => {
    if (!res.data) return null;

    const transformedUsers = res.data.users?.map((user) => {
      return {
        ...user,
        roles: user.roles
          ?.map((role) => ({
            ...role,
            name: fleetUserHelpers.getRoleName(role),
            type: fleetUserHelpers.getRoleType(role.name),
            description: fleetUserHelpers.getRoleDescription(role),
          }))
          .sort(fleetUserHelpers.sortRoles),
      };
    });

    // Future proofing with the spread in case more properties get added at top level
    return {
      ...res.data,
      users: transformedUsers,
    };
  });

export const getOrgInfo = async () =>
  fleetApiClient.GET('/fleet/v1/organization').then((res) => res?.data ?? null);

export const getInvitations = async () =>
  fleetApiClient.GET('/fleet/v1/invitations').then((res) => res.data ?? null);

export const createInvitation = async (vars: { email: string }) =>
  fleetApiClient
    .POST('/fleet/v1/invitations', {
      body: {
        email: vars.email,
      },
    })
    .then((res) => res.data ?? null);
